const pageTypes = {
    PURCHASE_WIDGET_SDK_PAGE: "PurchaseWidgetSDK_page",
};

export default pageTypes;
